import { getAuth, getAuthToken, LOCAL_STORAGE } from '../../../config';

export const ResponseStatus = {
    UNKNOWN: 'unknown',
    ERROR: 'error',
    SUCCESS: 'success',
    WARNING: 'warning',
    INFO: 'info',
    FIELDS_VALIDATION: 'fields_validation'
};

export const getFetchDefaultHeaders = (type: string) => {
    return {
        Authorization: `Token ${getAuthToken(String(type))}`
    };
};
